import { render, staticRenderFns } from "./DuplicatedHotelsDialog.vue?vue&type=template&id=6004af2a&scoped=true&"
import script from "./DuplicatedHotelsDialog.vue?vue&type=script&lang=js&"
export * from "./DuplicatedHotelsDialog.vue?vue&type=script&lang=js&"
import style0 from "./DuplicatedHotelsDialog.vue?vue&type=style&index=0&id=6004af2a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6004af2a",
  null
  
)

export default component.exports